import { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import {
  INSTANT_MOTION_MEDIA_QUERY,
  shouldUseInstantMotion,
} from '../lib/instantMotion.js';

export function useInstantMotion() {
  const prefersReducedMotion = useReducedMotion();
  const [coarseOrNarrow, setCoarseOrNarrow] = useState(
    () =>
      typeof window !== 'undefined' &&
      window.matchMedia(INSTANT_MOTION_MEDIA_QUERY).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(INSTANT_MOTION_MEDIA_QUERY);
    const sync = () => setCoarseOrNarrow(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return shouldUseInstantMotion({
    coarseOrNarrow,
    prefersReducedMotion,
  });
}
